import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Popover,
} from "@mui/material";

import {
  Container,
  Title,
  Divider,
  FollowerContainer,
  ButtonContainer,
  TextName,
  TextContainer,
  GridFollowContainer,
} from "./styles";

import { Box } from "@mui/system";
import { useUser } from "../../contexts/UserContext";
import { useTranslation } from "react-i18next";

export default function FollowersList() {
  const {
    getMetaFollowers,
    metaFollers,
    removeMetaFollow,
    updateExpCopy,
    getMetaInfo, // <-- veio do UserContext.js
  } = useUser();

  const { t } = useTranslation();

  const [anchorElExp, setAnchorElExp] = useState(null);
  const [anchorElInfo, setAnchorElInfo] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [vencimento, setVencimento] = useState("");
  const [infoData, setInfoData] = useState(null);

  useEffect(() => {
    getMetaFollowers();
  }, []);

  const removeFollowExec = (id, name) => {
    removeMetaFollow(id, name);
    window.location.reload();
  };

  const handleOpenExpPopover = (event, userId) => {
    setAnchorElExp(event.currentTarget);
    setSelectedUser(userId);
  };

  const handleCloseExpPopover = () => {
    setAnchorElExp(null);
    setSelectedUser(null);
    setVencimento("");
  };

  const handleSaveVencimento = async () => {
    if (selectedUser && vencimento) {
      await updateExpCopy(selectedUser, vencimento);
      handleCloseExpPopover();
    }
  };

  const handleShowMetaInfo = async (userId, event) => {
    const data = await getMetaInfo(userId);
    if (data) {
      setInfoData(data);
      setAnchorElInfo(event.currentTarget);
    }
  };

  const handleCloseInfoPopover = () => {
    setAnchorElInfo(null);
    setInfoData(null);
  };

  const formatExp = (expCopy) => {
    if (expCopy > 0) {
      const d = new Date(expCopy * 1000);
      const day   = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year  = d.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return "Indefinido";
  };


  return (
    <Container>
      <Title>Lista de seguidores</Title>
      <Divider />

      <GridFollowContainer>
        {metaFollers.length > 0 &&
          metaFollers.map((seguidor) => (
            <FollowerContainer key={seguidor.id}>
              <TextContainer>
                <TextName className="follower">{seguidor.name}</TextName>
                <TextName className="follower">ID: {seguidor.id}</TextName>
                <TextName className="follower">
                  Expira: {formatExp(seguidor.expCopy)}
                </TextName>
              </TextContainer>

              <ButtonContainer>
                <div
                  className="removeBtn"
                  onClick={() => removeFollowExec(seguidor.id, seguidor.name)}
                >
                  Remover
                </div>

                <div
                  className="desableBtn"
                  onClick={(e) => handleShowMetaInfo(seguidor.id, e)}
                >
                  Info
                </div>

                <div
                  className="expBtn"
                  onClick={(e) => handleOpenExpPopover(e, seguidor.id)}
                >
                  Exp
                </div>
              </ButtonContainer>
            </FollowerContainer>
          ))}
      </GridFollowContainer>

      {/* Popover Exp */}
      <Popover
        open={Boolean(anchorElExp)}
        anchorEl={anchorElExp}
        onClose={handleCloseExpPopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box p={2} display="flex" flexDirection="column" gap={1}>
          <TextField
            label="Vencimento"
            variant="outlined"
            value={vencimento}
            onChange={(e) => setVencimento(e.target.value)}
            size="small"
          />
          <Box display="flex" justifyContent="space-between">
            <Button
              onClick={handleSaveVencimento}
              variant="contained"
              color="primary"
            >
              Salvar
            </Button>
            <Button
              onClick={handleCloseExpPopover}
              variant="outlined"
              color="secondary"
            >
              Cancelar
            </Button>
          </Box>
        </Box>
      </Popover>

      {/* Popover Info */}
      <Popover
      open={Boolean(anchorElInfo)}
      anchorEl={anchorElInfo}
      onClose={handleCloseInfoPopover}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <Box p={2}>
        {infoData ? (
          <>
            <div>
              <strong>UserID:</strong> {infoData.userid}
            </div>
            <div>
              <strong>Vencimento:</strong>{" "}
              {infoData.expCopy > 0 ? (
                (() => {
                  const d = new Date(infoData.expCopy * 1000);
                  const date = d.toLocaleDateString("pt-BR");
                  const time = d.toLocaleTimeString("pt-BR", {
                    hour: "2-digit",
                    minute: "2-digit",
                  });
                  return `${date} ${time}`;
                })()
              ) : (
                <em>Sem expiração definida</em>
              )}
            </div>
          </>
        ) : (
          <div>Carregando...</div>
        )}
      </Box>
    </Popover>

    </Container>
  );
}
